export default __webpack_public_path__ + "static/media/fourJokersDoor.42e786d9.jpg";